// Shared behaviour: mobile nav toggle only. Keep it boring and reliable.
(function () {
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('mainnav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    var open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.textContent = open ? 'Close' : 'Menu';
  });
})();
